import { Utilities } from '@base/utils/Utilities'

export class RoundRestoreUtil {
    public static readonly LOCAL_STORAGE_KEY: string = 'roundInProgress'

    public static startRound(): void {
        if (Utilities.isLocalStorageAvailable()) {
            localStorage.setItem(RoundRestoreUtil.LOCAL_STORAGE_KEY, 'true')
        }
    }

    public static isRoundActive(): boolean {
        if (Utilities.isLocalStorageAvailable()) {
            return localStorage.getItem(RoundRestoreUtil.LOCAL_STORAGE_KEY) === 'true'
        }

        return false
    }

    public static stopRound(): void {
        if (Utilities.isLocalStorageAvailable()) {
            localStorage.removeItem(RoundRestoreUtil.LOCAL_STORAGE_KEY)
        }
    }
}
